import { render } from "./PolicyTracking.vue?vue&type=template&id=e5ab2bee&scoped=true"
import script from "./PolicyTracking.vue?vue&type=script&lang=js"
export * from "./PolicyTracking.vue?vue&type=script&lang=js"

import "./PolicyTracking.vue?vue&type=style&index=0&id=e5ab2bee&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5ab2bee"]])

export default __exports__